function normalizeTagArray(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'string' && value.trim()) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  return [];
}

export function buildVehicleInfoForKnowledgeMatch({
  inputFormData,
  historyMode = false,
  historyPlanData = null
}) {
  const vehicleInfo = {
    fault_phenomenon_id: inputFormData.fault_phenomenon_id,
    control_unit_type_id: inputFormData.control_unit?.type_id || null,
    control_unit_brand_id: inputFormData.control_unit?.brand_id || null,
    control_unit_model_id: inputFormData.control_unit?.model_id || null,
    engine_info_id: inputFormData.engine_info_id,
    vehicle_type_id: inputFormData.vehicle_info?.type_id || null,
    vehicle_brand_id: inputFormData.vehicle_info?.brand_id || null,
    vehicle_model_id: inputFormData.vehicle_info?.model_id || null,
    subsystem_type_id: inputFormData.subsystem_info?.type_id || null,
    subsystem_brand_id: inputFormData.subsystem_info?.brand_id || null,
    subsystem_model_id: inputFormData.subsystem_info?.model_id || null,
    component_type_id: inputFormData.component_info?.type_id || null,
    component_brand_id: inputFormData.component_info?.brand_id || null,
    component_model_id: inputFormData.component_info?.model_id || null,
    system_voltage_id: inputFormData.system_voltage_id
  };

  if (historyMode && historyPlanData) {
    vehicleInfo.controlUnits = normalizeTagArray(historyPlanData.controlUnits);
    vehicleInfo.subsystems = normalizeTagArray(historyPlanData.subsystems);
    vehicleInfo.components = normalizeTagArray(historyPlanData.components);
    vehicleInfo.engines = normalizeTagArray(historyPlanData.engines);
    vehicleInfo.vehicles = normalizeTagArray(historyPlanData.vehicles);
  }

  return vehicleInfo;
}
